<script setup lang="ts">
import { NTabs } from 'naive-ui'
import { useAttrs } from 'vue'

const props = withDefaults(defineProps<{
  value?: string | number
  defaultValue?: string | number
  type?: 'line' | 'card' | 'segment'
  size?: 'small' | 'medium' | 'large'
  closable?: boolean
  addable?: boolean
  tabStyle?: any
  paneStyle?: any
  animated?: boolean
  tabBarStyle?: any
  onUpdateValue?: (value: string | number) => void
  onAdd?: () => void
  onClose?: (name: string | number) => void
  onTabClick?: (name: string | number) => void
}>(), {
  value: undefined,
  defaultValue: undefined,
  type: 'line',
  size: 'medium',
  closable: false,
  addable: false,
  tabStyle: undefined,
  paneStyle: undefined,
  animated: true,
  tabBarStyle: undefined,
})

const emit = defineEmits<{
  'update:value': [value: string | number]
  'add': []
  'close': [name: string | number]
  'tab-click': [name: string | number]
}>()

const attrs = useAttrs()

const onUpdateValue = (value: string | number) => {
  emit('update:value', value)
}

const onAdd = () => {
  emit('add')
}

const onClose = (name: string | number) => {
  emit('close', name)
}

const onTabClick = (name: string | number) => {
  emit('tab-click', name)
}
</script>

<template>
  <NTabs
    :value="value"
    :default-value="defaultValue"
    :type="type"
    :size="size"
    :closable="closable"
    :addable="addable"
    :tab-style="tabStyle"
    :pane-style="paneStyle"
    :animated="animated"
    :tab-bar-style="tabBarStyle"
    v-bind="attrs"
    @update:value="onUpdateValue"
    @add="onAdd"
    @close="onClose"
    @tab-click="onTabClick"
  >
    <slot />
  </NTabs>
</template>

<style scoped>
/* Custom styles can be added here if needed */
</style>
